import React from 'react';
import { Spinner } from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';

const CustomSweetAlert = ({ type, title, message, showCancel = true, onConfirm, onCancel }) => {
    if (type === "loading") {
        return <SweetAlert
            showConfirm={false}
            showCancel={false}
        >
            <Spinner
                animation="border"
                style={{
                    width: "200px",
                    height: "200px",
                    border: "9px solid #fff",
                    borderRadius: "50%",
                    borderTopColor: "#1abc9c",
                    fontSize: "60px",
                }}
            />
            <h3>Loading Induction ...</h3>

        </SweetAlert>
    }
    return (
        <SweetAlert
            type={type}
            showCancel={showCancel === false ? false : type === "success" ? false : true}
            style={{ display: "block", marginTop: "-100px", whiteSpace: "pre-wrap" }}
            title={title}
            onConfirm={() => onConfirm && onConfirm()}
            onCancel={() => onCancel && onCancel()}
            confirmBtnBsStyle="info"
            cancelBtnBsStyle="danger"
            cancelBtnText="Cancel"
        >
            {message}
        </SweetAlert>
    );
};

export default CustomSweetAlert;